import { Avatar } from 'grommet'
import { useState } from 'react'
import { Badge } from '..'
import { CaretDownIcon } from '../../../assets/svgs'
import { src } from '../../../constants'

type Props = {
  status?: boolean
  date: string
  name: string
  note: string
  index?: number
}

export const AddendumCard = ({ date, name, status, note, index }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className="mb-2 pt-3 bg-white shadow-sm">
      <h2 className="text-lg font-semibold text-gray-900">Addendum {index}</h2>
      <button
        aria-controls="addendum-content"
        aria-expanded={isExpanded}
        className="w-full flex justify-between items-center py-3 focus:outline-none transition-colors"
        onClick={() => setIsExpanded(prev => !prev)}
        type="button"
      >
        <div className="flex divide-x gap-3 text-black items-center">
          <p className="">
            Date & Time:
            <span className="ml-2 text-[#333333]">{date}</span>
          </p>
          <div className="pl-3 inline-flex">
            Author:
            <span className="ml-2 text-[#333333] inline-flex">
              <Avatar size="20px" src={src} />
              {name}
            </span>
          </div>
          {status && (
            <div className="pl-3">
              <Badge label="completed" status="completed" />
            </div>
          )}
        </div>
        <span
          aria-hidden="true"
          className={`ml-4 transition-transform duration-300 ease-in-out ${isExpanded ? 'rotate-180' : 'rotate-0'}`}
        >
          <CaretDownIcon />
        </span>
      </button>
      <div
        aria-hidden={!isExpanded}
        className={`overflow-hidden transition-all duration-300 ease-in-out ${isExpanded ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`}
        id="addendum-content"
        style={{ willChange: 'max-height, opacity' }}
      >
        <div className="py-4 px-2 h-max overflow-auto">
          <div className="prose prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: note }} />
        </div>
      </div>
    </div>
  )
}
